import { createApi } from '@reduxjs/toolkit/query/react'

import { CONSTS } from '../config/objectConst'
import { axiosBaseQuery } from './utils/rtk'

export const enum Tag {
	Campaign = 'C',
	Contact = 'Co',
	Executions = 'E',
	ExecutionsStatistics = 'ES',
	Imports = 'I',
	ScheduledMessages = 'SM',
	Subscription = 'S',
	TeamMembers = 'TM',
	Webhooks = 'W',
	WorkspaceStats = 'WS'
}

export const apiRTK = createApi({
	baseQuery: axiosBaseQuery({
		baseUrl: CONSTS.API.URL
	}),
	endpoints: () => ({}),
	reducerPath: 'api',
	tagTypes: [
		Tag.Campaign,
		Tag.Contact,
		Tag.Executions,
		Tag.ExecutionsStatistics,
		Tag.Imports,
		Tag.ScheduledMessages,
		Tag.Subscription,
		Tag.TeamMembers,
		Tag.Webhooks,
		Tag.WorkspaceStats
	]
})
